import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLinkedin,
  faFacebook,
  faInstagram,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";
import "./Footer.css";
import Logo from "images/goopter-logo.png";
import { FormattedMessage } from "react-intl";
import { formatText } from "util/helper";
import axios from "axios";
import tawkTo from "tawkto-react";
import { Link } from "react-router-dom";
import { rootUrl } from "config/setting";

export default function Footer(props) {
  const footer = props.footer;
  const footer2 = props.footer2;
  const [footerArr, setFooterArr] = useState();
  const [footer2Arr, setFooter2Arr] = useState();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { email } = e.target.elements;
    let details = {
      "your-email": email.value,
    };

    const form = new FormData();
    for (const field in details) {
      form.append(field, details[field]);
    }
    axios
      .post(
        `${rootUrl}/wp-json/contact-form-7/v1/contact-forms/428/feedback`,
        form,
        { headers: { "content-type": "multipart/form-data" } }
      )
      .then(function (response) {
        console.log(response);
        alert(response.data.message);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    makeMenuArr(footer, setFooterArr);
    makeMenuArr(footer2, setFooter2Arr);
  }, [footer, footer2]);

  const makeMenuArr = (menu = footer, setPmenu) => {
    const parents = [];
    menu.map((item) => {
      //  find parents
      if (item.menu_item_parent === "0") {
        item.children = [];
        parents.push(item);
      }
    });
    //  find children and assign it to corresponding parent
    menu.map((item) => {
      if (item.menu_item_parent != "0") {
        parents.map((parent) => {
          if (item.menu_item_parent === parent.ID.toString()) {
            parent.children.push(item);
          }
        });
      }
    });
    //how to find grand children
    setPmenu(parents);
  };

  const tawkToPropertyId = process.env.REACT_APP_TAWK_ID;

  // Direct Chat Link
  // https://tawk.to/chat/tawkToPropertyId/tawkToKey

  const tawkToKey = process.env.REACT_APP_TAWK_KEY;

  useEffect(() => {
    tawkTo(tawkToPropertyId, tawkToKey);
  }, []);
  return (
    <>
      <div className="footer">
        <div className="container">
          <div className="row upper-footer">
            {footerArr
              ? footerArr.map((item) => (
                  <div className="col-lg-3" key={item.ID}>
                    <h5>
                      <Link to={item.url}>
                        {<FormattedMessage id={formatText(item.title)} />}
                      </Link>
                    </h5>
                    <ul>
                      {item.children.length > 0
                        ? item.children.map((childItem) => (
                            <li key={childItem.ID}>
                              <Link to={childItem.url}>
                                {
                                  <FormattedMessage
                                    id={formatText(childItem.title)}
                                  />
                                }
                              </Link>
                            </li>
                          ))
                        : null}
                    </ul>
                  </div>
                ))
              : null}
            <div className="col-lg-6 newsletter-wrapper">
              <div className="newsletter-wrapper">
                <h5>{<FormattedMessage id={formatText("newsletter")} />}</h5>
                <p>
                  <FormattedMessage id={formatText("newsletter_desc")} />
                </p>
                <form onSubmit={handleSubmit}>
                  <div className="form-group d-flex">
                    <input
                      type="text"
                      placeholder="Email"
                      id="email"
                      name="your-email"
                    />
                    <button className="green-button" type="submit">
                      <FormattedMessage id={formatText("submit")} />
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="row mt-5">
            {footer2Arr
              ? footer2Arr.map((item) => (
                  <div className="col-lg-3" key={item.ID}>
                    <h5>{<FormattedMessage id={formatText(item.title)} />}</h5>
                    <ul>
                      {item.children.length > 0
                        ? item.children.map((childItem) => (
                            <li key={childItem.ID}>
                              <Link to={childItem.url}>
                                {
                                  <FormattedMessage
                                    id={formatText(childItem.title)}
                                  />
                                }
                              </Link>
                            </li>
                          ))
                        : null}
                    </ul>
                  </div>
                ))
              : null}
            <div className="col-lg-3 sns">
              <h5>
                {" "}
                <FormattedMessage id={formatText("follow_us")} />
              </h5>
              <div className="icons">
                <a href="https://www.linkedin.com/company/goopter">
                  <FontAwesomeIcon
                    icon={faLinkedin}
                    style={{ fontSize: "32px" }}
                  />
                </a>
                <a href="https://www.facebook.com/gooptercommerce/">
                  <FontAwesomeIcon
                    icon={faFacebook}
                    style={{ fontSize: "32px" }}
                  />
                </a>
                <a href="https://www.instagram.com/goopter_commerce/">
                  <FontAwesomeIcon
                    icon={faInstagram}
                    style={{ fontSize: "32px" }}
                  />
                </a>
                <a href="https://twitter.com/gooptercommerce">
                  <FontAwesomeIcon
                    icon={faTwitter}
                    style={{ fontSize: "32px" }}
                  />
                </a>
              </div>
              <div className="desktop logo">
                <img src={Logo} alt="logo" />
              </div>
            </div>
          </div>

          <div className="mobile logo col-lg-2">
            <img src={Logo} alt="logo" />
          </div>
        </div>
        <div className="lower-foopter text-center">
          <Link to="/term-conditions">
            <FormattedMessage id={formatText("term_conditions")} />
          </Link>
          <Link to="/privacy-policy">
            <FormattedMessage id={formatText("privacy_policy")} />
          </Link>
          <Link to="/sitemap">
            <FormattedMessage id={formatText("sitemap")} />
          </Link>
        </div>
      </div>
    </>
  );
}
